module.exports = __webpack_public_path__ + "static/media/quirky-rectangle.413fe5e1.svg";